<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/133yQxZ/tc-custom/9781504083409.jpg?1705290534263" alt="This image is the cover for the book Pigs is Pigs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pigs is Pigs
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In this 1905 humorous short story, confusion over what a guinea pig truly is causes trouble for a stubborn railway agent.</b></p> Mr. Morehouse would very much like to collect his two guinea pigs from the express office of the Interurban Express Company. However, railway agent Mike Flannery wants to charge him the  livestock rate of thirty cents—not the lower pet rate of twenty-five cents. “Pigs is pigs,” he tells an enraged Mr. Morehouse, believing that “guinea” is merely an indication of the pigs’ national origin. With both men refusing to budge, the guinea pigs remain in Flannery’s office where he is forced to feed and care for them. Just when Flannery thinks he’s in the clear, his problems begin to multiply . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellis Parker Butler
      </h2>
      
      <p class="authorDescription body article">Ellis Parker Butler (1869&ndash;1937) was an American author of more than thirty books and two thousand stories and essays. His career spanned more than forty years, and his stories, poems, and articles were published in more than 225 magazines. Despite the enormous volume of his work, Butler was, for most of his life, only a part-time author. He worked full-time as a banker and was very active in his local community. A founding member of both the Dutch Treat Club and the Authors League of America, Butler was an always-present force in the New York City literary scene. He died in Williamsville, Massachusetts.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?313869ca